var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#ff9933"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19868 13.6654L10.5001 23.6895C10.5419 23.8712 10.7036 24 10.89 24H23.11C23.2964 24 23.4581 23.8712 23.4999 23.6895L25.8013 13.6654C25.8784 13.3294 25.5229 13.0597 25.2202 13.2246L20.8571 15.6L17.3294 10.4783C17.1704 10.2475 16.8296 10.2475 16.6706 10.4783L13.1429 15.6L8.77981 13.2246C8.47708 13.0597 8.12155 13.3294 8.19868 13.6654Z",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.611fb76643ccaaa58c543373a0d32cc2.svg";
export { ForwardRef as ReactComponent };